/**
Project: Voice Panel (c)
Title: Navbar
Description: Component for displaying the navigation menubar of the application
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  Text,
  Image,
  CloseIcon,
  Popup,
  Menu,
  MenuItem,
  Button,
  Avatar,
  Flex,
  Dialog
} from "@fluentui/react-northstar";
import SippioVoicePanelLogo from "../../../../../assets/images/SIPPIO-VoicePanel-Logo.png";
import { capitalizeFirstLetter, withdrawAppConsent } from "../../common/actions/general-actions";
import IdentityIcon from "../../../../../assets/images/identity_icon.png";
import IntlTranslate from "../../../../core/helpers/intl-translate";
import IntlUtil from "../../../../core/helpers/intl-util";
import { AppURLProps } from "../../../../core/settings/app-urls";
import { setClientNavigator } from "../../../../core/actions/common-actions";
import { AppConstants } from "../../../../core/settings/app-constants";
import className from "classnames/bind";
import { getAppInsights } from "../../../../core/settings/azure-insights-config";
import AccountPicker from "./multi-account-picker";
import TokenUtil from "../../../../core/helpers/token-util";
import { AppConfigProps } from "../../../../core/settings/app-config";
import { VoiceAdminConstants } from "../settings/voice-admin-constants";
import UserConsent from "./user-consent";
import axios from "axios";
import TelemetryUtil from "../../../../core/helpers/telemetry-util";

class Navbar extends Component {
  _intl_ns_common = "common";
  _intl_ns_vpa_common = "vpa_common";
  _intl_ns_vpa_navbar = "vpa_navbar";
  _azureInsights = getAppInsights();
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isUserConsentModalOpen:false,
      isConsentSubmitted:false,
      isConsentWithdrawModalOpen:false,
      
    };
    this.showMobileToggle = this.showMobileToggle.bind(this);
    this.closeMobileToggle = this.closeMobileToggle.bind(this);
  }

 
  showMobileToggle = () => {
    this.setState({ isOpen: true });
  };

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };
  handleEscape(e) {
    if (e.key === "Escape") {
      this.setState({ isOpen: false });
    }
  }
  async componentDidMount() {
    this._isMounted = true;
    await this.props.setClientNavigator();
  }
  componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }
  closeMobileToggle = () => {
    this.setState({ isOpen: false });
  };

  signout = async () => {
    await this.props.history.push(AppURLProps.signout);
  };
  handleConsentSubmit=async()=>{
    await this.setStateAsync({ isConsentSubmitted: true,              isConsentWithdrawModalOpen:false
    });
    let tokenData=TokenUtil.getIdentitySippioAccessTokenData();
    let userConsent={
  userEmail: tokenData.userEmail,
  accountNumber: tokenData.accountNumber,
  processStatus: VoiceAdminConstants.GENERAL.CONSENT_STATUS.WITHDRAWN,

    }
    await withdrawAppConsent(this.props.userConsentData?.consentUserId,userConsent,this._cancelToken).then(async(res)=>{
      if(res&&res.status===AppConfigProps.httpStatusCode.ok&&res?.data?.result){
        await this.setStateAsync({
          isUserConsentModalOpen:false
        });
        await this.signout();
        await this.setStateAsync({ isConsentSubmitted: false });
      }else{
        await this.setStateAsync({
          isUserConsentModalOpen:false
        });
        await this.signout();
        await this.setStateAsync({ isConsentSubmitted: false });
      }
    }).catch(async(err)=>{
      TelemetryUtil.logException(err);
      await this.setStateAsync({
        isUserConsentModalOpen:false
      });
      await this.signout();
      await this.setStateAsync({ isConsentSubmitted: false });

    })
  }
  handleConsentReject=async()=>{
    await this.setState({
      isUserConsentModalOpen:false,
    })
  }
  handleUserConsentModalOpen=async()=>{
    await this.setStateAsync({
      isUserConsentModalOpen:true
    })
  }
 handleWithdrawConsentModalOpen=async()=>{
  await this.setStateAsync({
    isConsentWithdrawModalOpen:true
  })
 }

  renderConsentWithdrawDialog = () => {
    if (this.state.isConsentWithdrawModalOpen === true) {
      return (
        <Dialog
          backdrop={true}
          cancelButton={IntlUtil.getText(
            this._intl_ns_vpa_common,
            "content.no"
          )}
          confirmButton={IntlUtil.getText(
            this._intl_ns_vpa_common,
            "content.yes"
          )}
          onConfirm={() => {
            this.handleConsentSubmit();
          }}
          onCancel={async() => {
            await this.setStateAsync({
              isConsentWithdrawModalOpen:false
            });
          }}
          open={this.state.isConsentWithdrawModalOpen}
          content={
            <>
              <Text className="vpa-page-dialog-info-text">
                {IntlUtil.getText(
                  this._intl_ns_vpa_common,
                  "notification.warning.withdrawConsentText"
                )}
              </Text>{" "}
              
            </>
          }
          className="vpa-page-dialog"
        />
      );
    }
  };
  showIdentityProfileWebview = () => {
    const subscriberIdentity = this.props.subscriberIdentity;
    const subscriberAccount = this.props.subscriberAccount;
    let identityProfile = "";
    if (subscriberAccount && subscriberIdentity) {
      this._azureInsights.setAuthenticatedUserContext(
        subscriberIdentity.userEmail,
        subscriberAccount.accountNumber,
        false
      );
      identityProfile = (
        <Popup position="below" pointing trigger={<div className="vpa-navbar-profile-header">
          <div className="vpa-navbar-identity navbar-profile-webview">
            <div className="vpa-navbar-username">
              {subscriberIdentity.userEmail}
            </div>
            <div className="vpa-navbar-account-number">
              {subscriberIdentity.accountNumber}
            </div>
          </div>
          <div className="vpa-navbar-identity-image">
            <Image
              src={IdentityIcon}
              alt={IntlUtil.getText(
                this._intl_ns_vpa_navbar,
                "content.userProfile"
              )}
              className="vpa-navbar-identity-icon"
            />
          </div>
        </div>
        } content={
          <div className="profile-card-wrapper">
            <div className="profile-card-active-user">
              <Avatar size="larger" name={capitalizeFirstLetter(subscriberIdentity.userDisplayName)} className="profile-card-active-user-image" />
              <Flex column>
                <div className="profile-card-active-user-displayname text-truncate text-semibold">{subscriberIdentity.userDisplayName}</div>
                <div className="profile-card-active-user-email text-truncate">{subscriberIdentity.userEmail}</div>
                <div className="profile-card-active-user-accountnumber text-truncate">{subscriberIdentity.accountNumber}</div>
                <div>
                {this.props.userConsentData?<Button className="text-truncate profile-button m-t-5 p-0 min-w-0"
                onClick={() => this.handleUserConsentModalOpen()}
                text
                primary
                content={<IntlTranslate
                  namespace={this._intl_ns_vpa_navbar}
                  keyId="content.userConsent"
                />} ></Button>:null}
                </div>
              <div>
              <Button className="text-truncate profile-button p-0 min-w-0 m-r-10"
                onClick={() => this.signout()}
                text
                primary
                content={<IntlTranslate
                  namespace={this._intl_ns_vpa_navbar}
                  keyId="content.signout"
                />} ></Button>
                </div>
              </Flex>
             
               
                
            </div>
            <AccountPicker
              handleInteractiveSignin={this.props.handleInteractiveSignin}
              history={this.props.history}
              capitalizeFirstLetter={capitalizeFirstLetter} />
            <div className="profile-card-app-version">{process.env.REACT_APP_BUILD_VERSION}</div>
          </div>
        } />
      )
    }
    return identityProfile;
  }

  showIdentityProfile = () => {
    if (this.props.clientNavigator &&
      this.props.clientNavigator.accessMode === AppConstants.CLIENT_NAVIGATOR.ACCESS_MODE_REGULAR_BROWSER) {
      return this.showIdentityProfileWebview();
    } else {
      return this.showIdentityProfileTeamsview();
    }
  }

  showIdentityProfileTeamsview = () => {
    const subscriberIdentity = this.props.subscriberIdentity;
    const subscriberAccount = this.props.subscriberAccount;
    let identityProfile = "";
    if (subscriberAccount && subscriberIdentity) {
      this._azureInsights.setAuthenticatedUserContext(
        subscriberIdentity.userEmail,
        subscriberAccount.accountNumber,
        false
      );
      identityProfile = (
        <Popup position="below" pointing trigger={
          <div className="vpa-navbar-profile-header">
            <div className="vpa-navbar-identity navbar-profile-webview">
              <div className="vpa-navbar-username">
                {subscriberIdentity.userEmail}
              </div>
              <div className="vpa-navbar-account-number">
                {subscriberIdentity.accountNumber}
              </div>
            </div>
            <div className="vpa-navbar-identity-image">
              <Image
                src={IdentityIcon}
                alt={IntlUtil.getText(
                  this._intl_ns_vpa_navbar,
                  "content.userProfile"
                )}
                className="vpa-navbar-identity-icon"
              />
            </div>
          </div>
        } content={
          <>
            <div className="profile-card-wrapper">
              <div className="profile-card-active-user">
                <Avatar size="larger" name={capitalizeFirstLetter(subscriberIdentity.userDisplayName)} className="profile-card-active-user-image" />
                <div className="profile-card-active-user-displayname text-truncate text-semibold">{subscriberIdentity.userDisplayName}</div>
                <div className="profile-card-active-user-email text-truncate">{subscriberIdentity.userEmail}</div>
                <div className="profile-card-active-user-accountnumber text-truncate">{subscriberIdentity.accountNumber}</div>
                <Button className="text-truncate p-0 min-w-0"
                  onClick={() => this.signout()}
                  text
                  content={<IntlTranslate
                    namespace={this._intl_ns_vpa_navbar}
                    keyId="content.signout"
                  />} ></Button>
              </div>
            </div>
          </>
        } />
      )
    }
    return identityProfile
  }

  renderDropdown(Submenu) {
    const item = Submenu.map((menu, index) => {
      if (menu.popup === true) {
        return (
          <Popup
            key={index}
            pointing
            position="after"
            on="hover"
            align="start"
            content={
              <Text
                content={
                  <IntlTranslate
                    namespace={this._intl_ns_vpa_navbar}
                    keyId={menu.labelKeyDesc}
                  />
                }
                className="text-fc-dark"
              />
            }
          >
            <NavLink
              key={index}
              to={menu.path}
              className="dropdown-link"
              onClick={this.closeMobileToggle}
            >
              <IntlTranslate
                namespace={this._intl_ns_vpa_navbar}
                keyId={menu.labelKeyId}
              />
            </NavLink>
          </Popup>
        );
      }
      if (menu.navDisplay === true) {
        return (
          <NavLink
            key={index}
            to={menu.path}
            className="dropdown-link"
            onClick={this.closeMobileToggle}
          >
            <IntlTranslate
              namespace={this._intl_ns_vpa_navbar}
              keyId={menu.labelKeyId}
            />
          </NavLink>
        );
      } else return false;
    });
    return item;
  }

  activeRoute(routeName) {
    return this.props.history.location.pathname.indexOf(routeName) > -1
      ? "active"
      : "";
  }

  render() {
    return (<>
      <header id="vpa-navbar" onKeyDown={this.handleEscape.bind(this)}>
        <nav className="navbar navbar-expand navbar-light">
          {this.props.clientNavigator &&
            this.props.clientNavigator.accessMode ===
            AppConstants.CLIENT_NAVIGATOR.ACCESS_MODE_REGULAR_BROWSER ? (
            <NavLink to={AppURLProps.home} className="navbar-brand">
              <Image
                src={SippioVoicePanelLogo}
                alt={IntlUtil.getText(
                  this._intl_ns_common,
                  "content.voicePanelBySippio"
                )}
                title={IntlUtil.getText(
                  this._intl_ns_common,
                  "content.voicePanelBySippio"
                )}
                className="vpa-image"
              />
            </NavLink>
          ) : null}
          {this.props.subscriberAccount?.accountNumber ? (
            <div className="navbar-toggler-wrapper float-right">
              <button
                onClick={this.showMobileToggle}
                className="navbar-toggler float-right"
                type="button"
                data-trigger="#main_nav"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          ) : null}
          <div
            className={className("navbar-collapse", {
              show: this.state.isOpen === true,
            })}
          >
            <div className="offcanvas-header mt-3">
              <div
                className="btn-close float-right"
                onClick={this.closeMobileToggle}
              >
                <CloseIcon size="large" />
              </div>
              {/* <h5 class="py-2 text-white"></h5> */}
            </div>
            <div>
              <Menu className="navbar-nav">
                {this.props.subscriberMenus &&
                  this.props.subscriberMenus.length > 0
                  ? this.props.subscriberMenus.map((menu, index) => {
                    if (menu.navDisplay === true) {
                      if (menu.child && menu.child.length > 0) {
                        return (
                          <MenuItem
                            inSubmenu={true}
                            menu={this.renderDropdown(menu.child)}
                            index={index}
                            key={`menu-${index}`}
                            className={`${this.activeRoute(
                              menu.path
                            )} nav-link`}
                          >
                            <IntlTranslate
                              namespace={this._intl_ns_vpa_navbar}
                              keyId={menu.labelKeyId}
                            />
                          </MenuItem>
                        );
                      } else {
                        return (
                          <MenuItem
                            as={NavLink}
                            to={menu.path}
                            key={`menu-${index}`}
                            className="nav-link"
                            onClick={this.closeMobileToggle}
                          >
                            <IntlTranslate
                              namespace={this._intl_ns_vpa_navbar}
                              keyId={menu.labelKeyId}
                            />
                          </MenuItem>
                        );
                      }
                    } else {
                      return null;
                    }
                  })
                  : null}
              </Menu>
            </div>
          </div>
          <div
            className={className("", {
              "offcanvas-active": this.state.isOpen === true,
            })}
            onClick={this.closeMobileToggle}
          ></div>
          <div id="vpa-navbar-profile">
            {this.showIdentityProfile()}
          </div>
        </nav>
      </header>
      {this.renderConsentWithdrawDialog()}
      {this.props.userConsentData?       
         <UserConsent
        type="withdraw"
                          isUserConsentModalOpen={
                            this.state.isUserConsentModalOpen
                          }
                          isConsentSubmitted={this.state.isConsentSubmitted}
                          handleConsentAccept={this.handleWithdrawConsentModalOpen}
                          handleConsentReject={this.handleConsentReject}
                          userConsentRecord={this.props.userConsentData}
                        />:null
}
    </>);
  }
}

const mapStateToProps = (state) => ({
  clientNavigator: state.appSettings.clientNavigator,
  subscriberIdentity: state.subscriberStore.subscriberIdentity,
  subscriberAccount: state.subscriberStore.subscriberAccount,
  subscriberMenus: state.subscriberStore.subscriberMenus,
  userConsentData:state.generalStore.userConsentData
});
const mapActionToProps = {
  setClientNavigator,
};

export default connect(mapStateToProps, mapActionToProps)(Navbar);
